module.exports = __webpack_public_path__ + "img/Mileage.9c2196f5.svg";